import { render, staticRenderFns } from "./sentList.vue?vue&type=template&id=205a4037&"
import script from "./sentList.vue?vue&type=script&lang=js&"
export * from "./sentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports